var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"calc(100vh - 120px)","margin-top":"-10px"}},[_c('iframe',{attrs:{"src":_vm.weburl,"width":"100%","height":"100%","allowfullscreen":"","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }